import type { PermissionTuple } from '~/utils/ability'
import type { LegacyRightsRequirement } from '~/utils/rbac'

/**
 * Module 17 — Caméras. Deux fonctionnalités : le flux (écran « Caméras » et les vues caméras
 * personnalisées) et la configuration caméra d'une boutique (écran « Camera Config »).
 */

export const CAMERA_STREAM_READ: PermissionTuple = ['read', 'cameras.cameras.stream']
export const CAMERA_STREAM_ADD: PermissionTuple = ['add', 'cameras.cameras.stream']
export const CAMERA_STREAM_EDIT: PermissionTuple = ['edit', 'cameras.cameras.stream']
export const CAMERA_STREAM_DELETE: PermissionTuple = ['delete', 'cameras.cameras.stream']

export const CAMERA_CONFIG_READ: PermissionTuple = ['read', 'cameras.cameras.config']
export const CAMERA_CONFIG_ADD: PermissionTuple = ['add', 'cameras.cameras.config']
export const CAMERA_CONFIG_EDIT: PermissionTuple = ['edit', 'cameras.cameras.config']
export const CAMERA_CONFIG_DELETE: PermissionTuple = ['delete', 'cameras.cameras.config']

/**
 * Droits v1 exigés tant que le flag `permission-v2` est OFF (où tous les tuples v2 passent).
 * Les contrôleurs backend conservent leurs gardes historiques et ajoutent l'opérateur support
 * comme alternative pour l'ensemble de cette page.
 */
export const CAMERA_OPERATOR_LEGACY_RIGHTS: LegacyRightsRequirement = {
  any: ['ADMIN', 'SUPPORT_OPERATOR'],
}

export const CAMERA_STOCK_LEGACY_RIGHTS: LegacyRightsRequirement = {
  any: ['STOCK_READER', 'SUPPORT_OPERATOR'],
}

export const CAMERA_MAINTENANCE_LEGACY_RIGHTS: LegacyRightsRequirement = {
  any: ['STOCK_ADMIN', 'STOCK_READER', 'SUPPORT_OPERATOR'],
}

export const CAMERA_CONFIG_LEGACY_RIGHTS = CAMERA_OPERATOR_LEGACY_RIGHTS
